import request from "@/utils/request";

export function getVideos(params) {
  return request({
    url: `/api/Videos/GetMuseumVideos/${params.museumId}`,
    method: `get`,
    params,
  });
}

export function getVideoId(id, params) {
  return request({
    url: `/api/Videos/GetMuseumVideo/${id}`,
    method: `get`,
    params,
  });
}

export function putVideo(id, data, params) {
  return request({
    url: `/api/Videos/UpdateVideo/${id}`,
    method: `put`,
    params,
    data,
  });
}

export function postVideo(data, params) {
  return request({
    url: `/api/Videos/AddVideo/${params.museumId}`,
    method: `post`,
    params,
    data,
  });
}

export function deleteVideo(id) {
  const params = {
    videoId: id,
  };
  return request({
    url: `/api/Videos/DeleteVideo/${id}`,
    method: "put",
    params,
  });
}
